// extracted by mini-css-extract-plugin
export var avatar = "teamspeak-widget-module--avatar--d4bad";
export var children = "teamspeak-widget-module--children--20fdb";
export var flex = "teamspeak-widget-module--flex--643b5";
export var game = "teamspeak-widget-module--game--5ba25";
export var idle = "teamspeak-widget-module--idle--60ea5";
export var imageWrapper = "teamspeak-widget-module--imageWrapper--fb1f0";
export var initials = "teamspeak-widget-module--initials--8caef";
export var lockButton = "teamspeak-widget-module--lockButton--19602";
export var muteWrapper = "teamspeak-widget-module--muteWrapper--194bd";
export var mutedButton = "teamspeak-widget-module--mutedButton--09ed0";
export var online = "teamspeak-widget-module--online--c01ad";
export var recordButton = "teamspeak-widget-module--recordButton--3aac6";
export var stale = "teamspeak-widget-module--stale--fd717";
export var teamspeakWidget = "teamspeak-widget-module--teamspeakWidget--2ac4e";
export var teamspeakWrapper = "teamspeak-widget-module--teamspeakWrapper--11b2e";
export var toggleButton = "teamspeak-widget-module--toggleButton--58008";
export var userName = "teamspeak-widget-module--userName--7f7af";
export var userWrapper = "teamspeak-widget-module--userWrapper--c2130";